import { useContext, useEffect, useState } from 'react';
import { InterfaceContext } from '../model/InterfaceProvider';
import { tabList } from '../model/StaticVariables';

export default function Tablist() {
    const { tab: selectedTab, setSelectedTab } = useContext(InterfaceContext);
    const [pageViewed, setPageViewed] = useState(false);

    const clickedTab = (e) => {
        const tabID = e.target.getAttribute('id').replace(/tab-/, '');
        // If using #more-pcm need to use this to enable map on tab change
        if (document.body.classList.contains('resize-on-tab-change')) {
            window.dispatchEvent(new Event('forceresize'));
        }
        setSelectedTab(tabList[tabID]);
    };
    return (
        <div id="tabs">
            <div role="tablist" className="tab-holder">
                {tabList.map((t) => {
                    const isSelected = t.id === selectedTab.id;
                    return (
                        <button key={t.id} className={`icon-${t.icon} ${isSelected ? 'active' : ''} ${t.hidden && 'hidden'}`} role="tab" aria-selected={isSelected} aria-hidden={t.hidden && !isSelected} onClick={clickedTab} aria-controls={'panel-' + t.slug} id={'tab-' + t.id}>
                            {t.label}
                            {t.close && <span className="close-details">X</span>}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
